import { Button } from '@zinc/ui';
import Checkbox from 'bz-core-controls/controls/next/form/checkbox';
import RadioButton from 'bz-core-controls/controls/next/form/radio';
import { action } from 'mobx';
import { observer } from 'mobx-react';
import React from 'react';
import { RBViewMode } from '../enums';
import type { RadioButtonListItemProps } from '../interfaces';

@observer
class RadioButtonListItem extends React.Component<RadioButtonListItemProps> {
  render() {
    const { viewMode, value, text, active, readOnly, name } = this.props;
    switch (viewMode) {
      case RBViewMode.checkbox:
        return (
          <Checkbox
            value={value}
            label={text}
            checked={active}
            disabled={readOnly}
            onChange={this.onClick}
          />
        );
      case RBViewMode.radioButton:
        return (
          <RadioButton
            value={value}
            label={text}
            checked={active}
            disabled={readOnly}
            onChange={this.onClick}
            name={name}
          />
        );
      case RBViewMode.button:
        return (
          <Button
            value={value}
            variant={active ? 'solid' : 'outline'}
            size="small"
            disabled={readOnly}
            onClick={this.onClick}
          >
            {text}
          </Button>
        );
      default:
        return null;
    }
  }

  @action.bound
  private onClick() {
    const { value, onChange } = this.props;
    return onChange.call(this, value);
  }
}

export default RadioButtonListItem;
